module.exports = __webpack_public_path__ + "img/analytics.8c90703.svg";